import React, { Component } from 'react';
import Cek from './Ceknik/Cek';

class DisdukComponent extends Component {
    state = {
        token: ""   
    }
    componentDidMount() {


    }
    render() {
        return (
            <div>
                <Cek token={this.state.token} />
            </div>
        )
    }
}

export default DisdukComponent